'use client';

import React from 'react';
import type { I18nContextValue } from '@/shared/lib/i18n/types';

const I18nContext = React.createContext<I18nContextValue | null>(null);

export function I18nProvider({
  value,
  children,
}: {
  value: I18nContextValue;
  children: React.ReactNode;
}) {
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n(): I18nContextValue {
  const ctx = React.useContext(I18nContext);
  if (!ctx) {
    throw new Error('useI18n must be used within <I18nProvider />');
  }
  return ctx;
}

